import { useTranslation } from 'react-i18next';

export function LanguageToggle() {
  const { i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(isEn ? 'fr' : 'en')}
      className="relative inline-flex h-8 w-[4.25rem] items-center rounded-full border border-border bg-surface shadow-sm transition-colors"
      aria-label="Change language"
    >
      <span
        className={`absolute top-0.5 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-primary-foreground shadow transition-all ${
          isEn ? 'left-0.5' : 'left-[calc(100%-1.875rem)]'
        }`}
      >
        {isEn ? 'EN' : 'FR'}
      </span>
      <span className="flex w-full items-center justify-between px-2.5 text-[10px] font-semibold text-text-muted">
        <span className={isEn ? 'opacity-0' : ''}>EN</span>
        <span className={isEn ? '' : 'opacity-0'}>FR</span>
      </span>
    </button>
  );
}
